<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: Lianzhidong
 * @Date: 2022-01-13 21:09:12
 * @LastEditors: Lianzhidong
 * @LastEditTime: 2022-03-15 23:22:18
-->
<template>
  <div class="box">
    <el-card class="box-header">
      <el-form
        :model="form"
        ref="searchForm"
        inline
        label-width="50px"
        label-position="right"
      >
        <el-form-item label="查询">
          <el-input
            class="input-item"
            v-model="form.phoneOrName"
            placeholder="请输入用户名或电话"
            clearable=""
          ></el-input>
        </el-form-item>
        <el-form-item label="角色">
          <el-select
            class="input-item"
            v-model="form.roleId"
            placeholder="请选择角色类型"
            clearable=""
          >
            <el-option
              v-for="(item, index) in roleList"
              :key="index"
              :label="item.label"
              :value="item.roleId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          ><el-button type="primary" icon="el-icon-search" @click="onSearch"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh-left" @click="onReset"
            >重置</el-button
          ></el-form-item
        >
      </el-form>
    </el-card>
    <el-card class="box-content">
      <el-table
        v-loading="isLoading"
        v-if="isTableReady"
        :height="tabelHeight"
        :data="list"
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        highlight-current-row
      >
        <el-table-column
          label="用户名"
          prop="userName"
          align="center"
        ></el-table-column>
        <el-table-column
          label="手机号"
          prop="phoneNum"
          align="center"
        ></el-table-column>
        <el-table-column
          label="角色名词"
          prop="roleName"
          align="center"
        ></el-table-column>
        <el-table-column label="状态" prop="apply" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.apply === 0">未审批</span>
            <span v-if="scope.row.apply === 1">已审批</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <span @click="onAgree(scope.row)" class="box-content-btn">
              <svg-icon icon-class="tongyi"></svg-icon>
              同意
            </span>
            <span @click="onReject(scope.row)" class="box-content-btn">
              <svg-icon icon-class="jujue"></svg-icon>
              拒绝
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card>
      <div class="box-footer">
        <div class="box-footer-count">{{ `共${total}条数据` }}</div>
        <el-pagination
          background
          layout="sizes, prev, pager, next"
          :page-sizes="[10, 20, 30, 40]"
          :total="total"
          :page-size="pageSize"
          :current-page="page"
          @current-change="onPageChange"
          @size-change="onSizeChange"
        >
        </el-pagination>
      </div>
    </el-card>
    <confirm-password
      :isDialogShow="isConfirmPassword"
      @onSubmit="onSubmit"
      @onClose="isConfirmPassword = false"
    ></confirm-password>
  </div>
</template>

<script>
import { roleList } from "@/utils/role";
import HTTP_USER_MANAGE from "@/api/userManage";
import ConfirmPassword from "@/components/ConfirmPassword";
import { calculateTableHeight } from "@/utils/tool";
export default {
  name: "UserManage",
  components: {
    ConfirmPassword,
  },
  data() {
    return {
      form: {
        phoneOrName: "",
        roleId: "",
      },
      list: [],
      total: 0,
      pageSize: 10,
      page: 1,
      isLoading: false,
      isTableReady: false,
      tabelHeight: 0,
      isConfirmPassword: false,
      params: null,
    };
  },
  computed: {
    roleList() {
      return roleList;
    },
  },
  mounted() {
    this.tabelHeight = calculateTableHeight(this.$refs["searchForm"], () => {
      this.isTableReady = true;
    });
    this.getList();
  },
  methods: {
    onPageChange(index) {
      this.page = index;
      this.getList();
    },
    onSizeChange(size) {
      this.pageSize = size;
      this.getList();
    },
    async getList() {
      this.isLoading = true;
      try {
        var params = {
          page: this.page,
          pageSize: this.pageSize,
          ...this.form,
        };
        const res = await HTTP_USER_MANAGE.getUserList(params);
        if (res.code === 200) {
          const { data } = res;
          console.log(data);
          this.list = data.userChecks;
          this.total = data.size;
        } else {
          this.$message.error(
            typeof res.msg === "string" ? res.msg : "请求出错，请联系管理员"
          );
        }
      } catch (e) {
        console.error(e);
      }
      this.isLoading = false;
    },
    //搜索
    onSearch() {
      this.page = 1;
      this.getList();
    },
    //重置
    onReset() {
      this.form = {
        phoneOrName: "",
        roleId: "",
      };
      this.page = 1;
      this.getList();
    },
    //同意
    onAgree(row) {
      this.params = {
        userIdList: [row.id],
        doublePassWord: "",
        apply: 1,
      };
      this.isConfirmPassword = true;
    },
    //点击审核
    onReject(row) {
      this.params = {
        userIdList: [row.id],
        doublePassWord: "",
        apply: -1,
      };
      this.isConfirmPassword = true;
    },
    async onSubmit(password) {
      this.params.doublePassWord = password;
      const res = await HTTP_USER_MANAGE.applyUser(this.params);
      console.log(res);
      if (res.code === 200) {
        this.isConfirmPassword = false;
        this.getList();
      } else {
        this.$message.error(
          typeof res.msg === "string" ? res.msg : "请求出错，请联系管理员"
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.input-item {
  width: 180px;
  margin-right: 18px;
}
.box {
  &-content {
    &-btn {
      color: #409eff;
      cursor: pointer;
      padding: 0 8px;
    }
  }
  &-footer {
    &-count {
      line-height: 32px;
      font-size: 12px;
    }
    display: flex;
    justify-content: space-between;
  }
}
</style>
